/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-constant-condition */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { motion } from 'framer-motion';
import React, {
    useCallback, useState, useEffect, useId, useContext,
} from 'react';
import { connect } from 'react-redux';
import { DistributorActions } from '../../redux/actions';
import { removeLastComma } from '../../redux/helper/RemoveComma';
import { distributorService } from '../../service/distributor.service';
import CustomToast from '../../Components/AlertPopup';
import HeaderContext from '../../Components/Context/HeaderContext';
import ListingTable from './ListingTable';
import './style.css';
import ExportModal from './ExportModal';

const subMenuAnimate = {
    enter: {
        opacity: 1,
        rotateX: 0,
        transition: {
            duration: 0.5,
        },
        display: 'block',
    },
    exit: {
        opacity: 0,
        rotateX: -15,
        transition: {
            duration: 0.5,
            delay: 0.3,
        },
        transitionEnd: {
            display: 'none',
        },
    },
};

function ManageCategories({ AddList, SkuList }) {
    const [mainCategory, setmainCategory] = useState([]);
    const [backgroundSelected, setbackgroundSeleced] = useState([]);
    const [loading, setloading] = useState(true);
    const [spinner, setspinner] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [productLoading, setproductLoading] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [showPopup, setshowPopup] = useState(false);
    const [color, setcolor] = useState(false);
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
    } = useContext(HeaderContext);
    const [categories, setcategories] = useState({
        main_category: '',
        category: '',
        sub_category1: '',
        sub_category2: '',
        sub_category3: '',

    });
    const initialState = {
        name: '',
        description: '',
        category: [],
        status: false,
    };
    const handleDependency = useCallback(
        async () => {
            const category = await distributorService.getOffersMainCategory();
            if (category.data.data.length > 0) {
                const arr = [];
                const val = {};

                category.data.data.forEach((mng, i) => {
                    arr.push({
                        id: `main--${i}`,
                        name: mng,
                        description: '',
                        category: [],
                        status: false,
                        CATEGORY_ID: arr.length + 1,
                        concat_segments: mng,

                    });
                });
                setmainCategory(arr);
                AddList(arr);
                setloading(false);
            }
        },
        [],
    );

    useEffect(() => {
        handleDependency();
    }, [handleDependency]);

    const handleProductList = async (id, page) => {
        const prodcuts = await distributorService.getProductsListBySegments(id, page);
        return prodcuts.data.data;
    };
    const CreatePayload = (payload) => {
        let final = {};
        const seg1 = payload.split(',').length > 1 ? payload.split(',')[1] : '';
        const seg2 = payload.split(',').length > 2 ? payload.split(',')[2] : '';
        const seg3 = payload.split(',').length > 3 ? payload.split(',')[3] : '';

        if (categories.main_category !== '' && categories.category === '') {
            final = { SEGMENT1: categories.main_category };
        }
        if (categories.category !== '' && seg1 && seg2 === '') {
            final = { SEGMENT2: seg1 };
        }
        if (categories.sub_category1 !== '' && seg2 !== '' && seg3 === '' && categories.sub_category2 === '') {
            final = { SEGMENT3: seg2 };
        }
        if (categories.sub_category2 !== '' && seg3 !== '') {
            final = { SEGMENT4: seg3 };
        }
        return final;
    };
    const handleCategories = useCallback(async (mainCategorySelected, type, sub1, sub2) => {
        let payload = '';
        Object.keys(categories).forEach((key) => {
            if (categories[key] !== '') {
                payload += `${categories[key]},`;
            }
        });
        const payload1 = categories.main_category;
        const seg1 = payload.split(',').length > 1 ? payload.split(',')[1] : '';
        const seg2 = payload.split(',').length > 2 ? payload.split(',')[2] : '';
        const seg3 = payload.split(',').length > 3 ? payload.split(',')[3] : '';
        const SKupayload = CreatePayload(payload);

        const response = await distributorService.getSku(SKupayload);
        if (!response.error && response.data.success_status) {
            const mainCategoryCopy = [...mainCategory];
            const idx = mainCategoryCopy.map((val) => val.concat_segments).indexOf(categories.main_category);
            if (categories.main_category !== '' && categories.category === '') {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, i) => {
                    item.id = `category--${i}`;
                    item.SEGMENT2 = item.name;
                    item.main_category = categories.main_category;
                    item.concat_segments = `${categories.main_category}.${item.name}`;
                    arr.push(item);
                });
                mainCategoryCopy[idx].category = arr;
            }
            const catid = mainCategoryCopy[idx]?.category?.map((val) => val.concat_segments).indexOf(`${categories.main_category}.${categories.category}`);
            const subcatid = mainCategoryCopy[idx]?.category[catid]?.category?.map((val) => val.concat_segments).indexOf(`${categories.main_category}.${categories.category}.${categories.sub_category1}`);
            let subcatid1 = subcatid && mainCategoryCopy[idx]?.category[catid]?.category[subcatid]?.category?.map((val) => val.concat_segments).indexOf(`${categories.main_category}.${categories.category}.${categories.sub_category1}.${SKupayload}`);

            if (categories.category !== '' && seg1 && seg2 === '') {
                const arr = [];
                const itemsArr1 = [];
                response.data.data.forEach((val) => {
                    itemsArr1.push({ name: val });
                });
                itemsArr1.forEach((item, i) => {
                    item.id = `subCategory1--${i}`;
                    item.SEGMENT3 = item.name;

                    item.concat_segments = `${categories.main_category}.${seg1}.${item.name}`;

                    arr.push(item);
                });
                mainCategoryCopy[idx].category[catid].category = arr;
            }
            if (categories.sub_category1 !== '' && seg2 !== '' && seg3 === '') {
                const arr = [];
                const itemsArr2 = [];
                if (response.data.data[0] !== null) {
                    response.data.data.forEach((val) => {
                        itemsArr2.push({ name: val });
                    });
                    itemsArr2.forEach((item, i) => {
                        item.SEGMENT4 = item.name;
                        item.concat_segments = `${categories.main_category}.${seg1}.${seg2}.${item.name}`;
                        item.id = `subCategory2--${i}`;
                        if (item.SEGMENT4 !== null) {
                            arr.push(item);
                        }
                    });
                    mainCategoryCopy[idx].category[catid].category[subcatid].category = arr;
                } else {
                    const productPayload = {
                        concat_segments: `${categories.main_category}.${categories.category}.${categories.sub_category1}.`,
                        page: 1,
                        limit: 10,
                    };
                    const data = await handleProductList(productPayload);
                    mainCategoryCopy[idx].category[catid].category[subcatid].products = data.data;
                    mainCategoryCopy[idx].category[catid].category[subcatid].current_page = Number(data.current_page);
                    mainCategoryCopy[idx].category[catid].category[subcatid].number_of_pages = Number(data.number_of_pages);
                    mainCategoryCopy[idx].category[catid].category[subcatid].mainIndex = idx;
                    mainCategoryCopy[idx].category[catid].category[subcatid].catIndex = catid;
                    mainCategoryCopy[idx].category[catid].category[subcatid].subcatIndex = subcatid;
                }
            }
            if (categories.sub_category2 !== '' && seg3 !== '') {
                const key = Object.keys(SKupayload);
                const temp = `${categories.main_category}.${categories.category}.${categories.sub_category1}.${SKupayload[key]}`;
                mainCategoryCopy[idx]?.category[catid]?.category[subcatid]?.category.map((val, i) => {
                    if (val.concat_segments === temp) {
                        subcatid1 = i;
                    }
                });
                const productPayload = {
                    concat_segments: `${categories.main_category}.${categories.category}.${categories.sub_category1}.${categories.sub_category2}`,
                    page: 1,
                    limit: 10,
                };
                const data = await handleProductList(productPayload);
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].products = data.data;
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].current_page = Number(data.current_page);
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].number_of_pages = Number(data.number_of_pages);
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].mainIndex = idx;
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].catIndex = catid;
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].subcatIndex = subcatid;
                mainCategoryCopy[idx].category[catid].category[subcatid].category[subcatid1].subcatIndex1 = subcatid1;
            }
            setspinner(false);
            AddList(mainCategoryCopy);
            setmainCategory(mainCategoryCopy);

            // setcriteriaCategory(response.data.data);
        } else {
            SetErrorMessage(response.message || 'Something went wrong');
            setTimeout(() => {
                setspinner(false);
                SetErrorMessage('');
            }, 3000);
        }
    }, [categories]);
    useEffect(() => {
        if (categories.main_category !== '') {
            handleCategories();
        }
    }, [handleCategories]);

    const handleSelect = (i, item) => {
        const copy = [...backgroundSelected];
        if (copy.includes(item.concat_segments)) {
            const idx = copy.indexOf(item.concat_segments);
            const removeItems = item.concat_segments.split('.');
            const tempArr = [];

            copy.filter((value) => {
                if (`/^${value}/`.match(item.concat_segments)) {
                    tempArr.push(value);
                }
            });
            tempArr.forEach((val) => {
                const index = copy.indexOf(val);
                copy.splice(index, 1);
            });
        } else {
            setspinner(true);
            if (item.id.split('--')[0] === 'main') {
                setcategories((prevState) => ({
                    ...prevState,
                    main_category: i,
                    category: '',
                    sub_category1: '',
                    sub_category2: '',
                }));
            }
            if (item.id.split('--')[0] === 'category') {
                setcategories((prevState) => ({
                    ...prevState,
                    main_category: item.concat_segments.split('.')[0],
                    category: i,
                    sub_category1: '',
                    sub_category2: '',
                    sub_category3: '',

                }));
            }
            if (item.id.split('--')[0] === 'subCategory1') {
                setcategories((prevState) => ({
                    ...prevState,
                    main_category: item.concat_segments.split('.')[0],
                    category: item.concat_segments.split('.')[1],
                    sub_category1: i,
                    sub_category2: '',
                    sub_category3: '',

                }));
            }
            if (item.id.split('--')[0] === 'subCategory2') {
                setcategories((prevState) => ({
                    ...prevState,
                    main_category: item.concat_segments.split('.')[0],
                    category: item.concat_segments.split('.')[1],
                    sub_category1: item.concat_segments.split('.')[2],
                    sub_category2: i,
                    sub_category3: '',

                }));
            }
            if (item.id.split('--')[0] === 'subCategory3') {
                setcategories((prevState) => ({
                    ...prevState,
                    main_category: item.concat_segments.split('.')[0],
                    category: item.concat_segments.split('.')[1],
                    sub_category1: item.concat_segments.split('.')[2],
                    sub_category2: item.concat_segments.split('.')[3],
                    sub_category3: i,
                }));
            }
            copy.push(item.concat_segments);
        }
        setbackgroundSeleced(copy);
    };
    const handleClick = async (pageValue, list, item, search) => {
        setproductLoading(true);
        const page = pageValue;
        const mainCategoryCopy = [...mainCategory];
        let productPayload = {};
        const Segment4Exist = item.concat_segments.split('.');
        if (Segment4Exist.length > 3) {
            productPayload = {
                concat_segments: mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].category[item.subcatIndex1].concat_segments,
                page,
                limit: 10,
                search: search === '' ? undefined : search,
            };
        } else {
            productPayload = {
                concat_segments: `${mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].concat_segments}.`,
                page,
                limit: 10,
                search: search === '' ? undefined : search,
            };
        }

        const prod = await handleProductList(productPayload);
        if (prod.success_status) {
            if (Segment4Exist.length > 3) {
                mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].category[item.subcatIndex1].products = prod.data;
                mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].category[item.subcatIndex1].current_page = Number(prod.current_page);
                mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].category[item.subcatIndex1].number_of_pages = prod.number_of_pages;
            } else {
                mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].products = prod.data;
                mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].current_page = Number(prod.current_page);
                mainCategoryCopy[item.mainIndex].category[item.catIndex].category[item.subcatIndex].number_of_pages = prod.number_of_pages;
            }
        } else {
            SetErrorMessage(prod.message || 'Something went wrong');

            setTimeout(() => {
                setspinner(false);
                SetErrorMessage('');
            }, 3000);
        }

        setmainCategory(mainCategoryCopy);
        AddList(mainCategoryCopy);

        setproductLoading(false);
    };
    const handleExport = useCallback((() => {
        if (exportClick) {
            setspinner(true);
        }
        distributorService.handleCategoriesExport(exportSelected).then((val) => {
            if (val.data.success_status) {
                setspinner(false);
                setshowPopup(true);
                settitle(val.data.message);
                window.open(val.data.url, '_blank');
                setexportClick(false);
                setexportSelected('');

                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 3000);
            }
        });
    }), [exportSelected]);
    useEffect(() => {
        handleExport();
    }, [handleExport]);

    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }
    const renderMenu = (items) => items.map((item, index) => (

        <motion.button
            key={`id--${index}`}
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: -20 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ ease: 'easeOut', duration: 2 }}
            className={`${!backgroundSelected.includes(item.concat_segments) ? 'collapsed' : ''} mt-1 inline-block py-2.5 text-[#090406] w-full font-semibold pl-2 text-left bg-[#E8E8F3] text-xs14 leading-tight rounded focus:outline-none active:transition ease-in-out box`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapseExample${index}`}
            aria-expanded="true"
            aria-controls={`collapseExample${index}`}
            style={{ backgroundColor: backgroundSelected.includes(item.concat_segments) ? '#E8E8F3' : '' }}

        >
            <div
                animate={backgroundSelected.includes(item.concat_segments) ? 'enter' : 'exit'}
                variants={subMenuAnimate}
                className="flex justify-between items-center cursor-pointer transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);"
                onClick={() => handleSelect(`${item.name}`, item)}
            >
                <p
                    className="name"
                >
                    {item.name}

                </p>
                <img src="images/chevron-Up-big.svg" alt="" className={`mr-9 ${!backgroundSelected.includes(item.concat_segments) ? 'image' : ''}`} />
            </div>
            <motion.div
                animate={backgroundSelected.includes(item.concat_segments) ? 'enter' : 'exit'}
                variants={subMenuAnimate}
                className={`collapse ${backgroundSelected.includes(item.concat_segments) ? 'show' : ''}`}
                id={`collapseExample${index}`}
            >
                <div className="mt-4 bg-[#FFFFFF] p-3 rounded-lg mx-5">
                    {item.category?.length > 0 && renderMenu(item.category) }

                    {!spinner && item?.products && (
                        <ListingTable
                            currentPage={Number(item.current_page)}
                            totalPage={Number(item.number_of_pages)}
                            list={item.products}
                            item={item}
                            handlePageClick={handleClick}
                            productLoading={productLoading}
                            subMenuAnimate={subMenuAnimate}
                            setspinner={setspinner}
                            title={title}
                            settitle={settitle}
                            setshowPopup={setshowPopup}

                        />
                    )}

                </div>
            </motion.div>
        </motion.button>

    ));
    function LoadingLogo() {
        return (
            <div>
                <div className="flex justify-center relative login-btn1">

                    {true && (
                        <div className="loader bg-[#FFFFFF] rounded-lg shadow-s2 absolute -top-[138px] left-1/2 -translate-x-1/2 px-7 pt-6 pb-3 min-h-[108px] min-w-[108px]">
                            <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_c0b34ayt.json" class="" background="transparent" speed="1" style={{ width: '58px', height: '58px' }} loop autoplay />
                            <p className="text-sm font-normal text-[#555259] text-center">Loading..</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
    return (
        <div className="py-6 pl-12 pr-[18px] main-screen relative " style={{ minHeight: '100vh' }}>
            {
                showPopup && (
                    <CustomToast
                        open
                        color={color ? '#ED1C24' : undefined}
                        message={<OtpSuccessMeessage />}
                    />
                )
            }
            <div className="flex justify-between">
                <h5 className="text-xs4 font-normal text-[#555259]">Categories and SKUs</h5>
                <div className="flex">
                    {/* <div className="relative">
                        <label htmlFor="search" />
                        <input type="text" name="search" id="search" className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" />
                        <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                    </div> */}
                    {/* <div className="pl-2 dropdown relative">
                        <button type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg">
                            Export
                        </button>
                        <ul className="dropdown-menu min-w-[140px] absolute hidden bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]" aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5" href="#">CSV</a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5" href="#">PDF</a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5" href="#">Excel</a>
                            </li>
                        </ul>
                    </div> */}
                    <ExportModal
                        exportClick={exportClick}
                        setexportClick={setexportClick}
                        subMenuAnimate={subMenuAnimate}
                        setexportSelected={setexportSelected}
                        csv="export-categories-csv"
                        pdf="html-to-pdf"
                        excel="export-categories-excel"
                    />

                </div>
            </div>
            <div className="md:space-x-1 space-y-1 md:space-y-0 mt-6" style={{ height: '100%' }}>
                <div className="relative">
                    {!loading && (
                        <>{renderMenu(SkuList.SkuList)}</>
                    )}
                </div>
                {spinner && (
                    <div className={true ? 'parentDisable' : ''} width="100%">
                        <div className="overlay-box">
                            <LoadingLogo />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

const mapState = (state) => {
    const { SkuList } = state;
    return { SkuList };
};
const createActors = {
    AddList: DistributorActions.AddadminSKUList,
};
const connectAdminUsers = connect(mapState, createActors)(ManageCategories);

export { connectAdminUsers as ManageCategories };
